import './Webinars.css'
import WebinarDescription from "./Description";
import { useEffect, useState } from "react";

const Webinars = (props) => {
    const [toggle, setToggle] = useState(false)
    const load_description = (e) => {
        let btn = e.target;
        if (toggle) {
            btn.previousSibling.style.height = '300px'
            setToggle(false)
            btn.textContent = 'Read More'
            btn.style.padding = '15px'
        } else {
            e.target.previousSibling.style.height = 'auto'
            setToggle(true)
            btn.textContent = 'Read Less'
            btn.style.padding = '0 0 15px 15px'
        }
    }

    return (
        <div className='webinar'>
            <div className='webinar-img-container'>
                <div className='webinar-img' >
                    <img alt='webinar-img' src={props.img} />
                </div>
                <div className='webinar-overlay' onClick={() => window.open(props.recording_link)}>
                    <div className='hr' />
                    <div className='vr' />
                </div>
                <div className='webinar-date'> {props.date} </div>
            </div>
            <WebinarDescription {...props} />
            <div className='load-text' onClick={load_description}>Read More</div>
        </div>
    )

}

export default Webinars;